import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { FieldErrors } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useMutation } from 'providers/tanstack-query/useMutation'
import { mapGraphQLErrors } from 'providers/tanstack-query/utils'
import { Schema } from '../schema'
import { toDTO } from './api/mapper'
import { UPDATE_PERFORMANCE_REPORT } from './api/mutation'
import { Data, Variables } from './api/types'
import { UseUpdatePerformanceReport } from './types'

export const useUpdatePerformanceReport = (): UseUpdatePerformanceReport => {
  const { t } = useTranslation('features/performance')
  const { enqueueSnackbar } = useSnackbar()
  const [loading, setLoading] = useState<boolean>(false)
  const [errors, setErrors] = useState<FieldErrors<Schema>>({})

  const { mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: UPDATE_PERFORMANCE_REPORT,
    onCompleted: async (data: Data) => {
      const {
        updateWorkspace: { errors },
      } = data
      setLoading(false)

      if (errors && errors.length > 0) {
        setErrors(mapGraphQLErrors(errors))
        enqueueSnackbar(t('form.error.update'), {
          variant: 'error',
        })
      } else {
        setErrors({})
        enqueueSnackbar(t('form.success.update'), {
          variant: 'success',
        })
      }
    },
    queriesToInvalidate: ['getPerformanceReport'],
  })

  const update = (data: Schema): void => {
    setLoading(true)

    mutateAsync({
      input: toDTO(data),
    })
  }

  return {
    errors,
    loading,
    update,
  }
}
